import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import { MentoringTabs, WebFukiTabs, SiputTabs } from './tabs.component';

import mentoring from './images/project-mentoring.png';
import webfuki from './images/project-webfuki.png';
import siput from './images/project-siput.png';

import './projects.styles.css';

const Projects = () => (
    <div id="projects">
    <Container fluid >
        <Row>
            <h2 className="projects">Projects</h2>
        </Row>

        <Row className="py-5">
            <Col lg={true} className="project-left">
                <img src={webfuki} alt="project-webfuki" draggable="false" className="project-img" />
            </Col>
            <Col lg={true} className="project-right">
                <h3 className="project-title">FUKI Fasilkom UI Website</h3>
                <p className="project-desc">
                FUKI is the Islamic organization of the Faculty of Computer Science 
                University of Indonesia (Fasilkom UI). The website is a platform to display 
                activities, bureaus and departments in FUKI Fasilkom UI, and information about 
                FUKI in general. This app is developed by the IT Force Bureau of FUKI Fasilkom UI.
                </p>
                <p className="tech-stack">
                    Django &middot; React &middot; Figma
                </p>
                <div className="projects-btns">
                <WebFukiTabs />
                </div>
            </Col>
        </Row>
            
        <Row className="py-5">
            <Col lg={{ order: 2 }} className="project-right-mentoring">
                <img src={mentoring} alt="project-mentoring" draggable="false" className="project-img" />
            </Col>
            <Col lg={{ order: 1 }} className="project-right">
                <h3 className="project-title">Mentoring Website</h3>
                <p className="project-desc">
                A web app for the needs of Islamic mentoring activities at the
                Faculty of Computer Science University of Indonesia (Fasilkom UI).
                This app is useful for managing and displaying the attendance of mentoring members.
                This app is developed by the IT Force Bureau of FUKI Fasilkom UI.
                </p>
                <p className="tech-stack">
                    Django REST &middot; React &middot; Figma
                </p>
                <div className="projects-btns">
                <MentoringTabs />
                </div>
            </Col>
        </Row>

        <Row className="py-5">
            <Col lg={true} className="project-left">
                <img src={siput} alt="project-siput" draggable="false" className="project-img" />
            </Col>
            <Col lg={true} className="project-right">
                <h3 className="project-title">SIPUT</h3>
                <p className="project-desc">
                A web app that serves as a centered system for the internals of FUKI’s design and publication needs.
                This app is developed by the IT Force Bureau of FUKI Fasilkom UI.
                </p>
                <p className="tech-stack">
                    Django REST &middot; React &middot; Figma
                </p>
                <div className="projects-btns">
                <SiputTabs />
                </div>
            </Col>
        </Row>

        <Row className="py-5 d-flex justify-content-center">
            <Button href="https://github.com/gpersable" target="_blank" className="btn-opensource">
                See my open source projects <i class="fab fa-github"></i>
            </Button>
        </Row>
    </Container>
    </div>
);

export default Projects;